const personalizationName = (personalizations, customization_id) =>
  personalizations.find(
    (p) => parseInt(p.id, 10) === parseInt(customization_id, 10),
  ).name;

export default personalizationName;
